import type { LinkButtonUnderlineMode } from '@/ui/buttons/button-styles/buildButtonClassName'
import type { ButtonVariant } from '@/ui/buttons/button-styles/ButtonStyles'

export function isLinkToneVariant(variant: ButtonVariant): boolean {
  return variant === 'link' || variant === 'link-highlighted'
}

export function getLinkUnderlineMode(underlined?: boolean): LinkButtonUnderlineMode | undefined {
  return underlined === false ? 'hover' : undefined
}
